<div
  class="overlay-element"
  [style.background]="background | elmSafeStyle"
  [style.opacity]="opacity | elmSafeStyle"
></div>
<ng-content></ng-content>
